import DataReducer from "./DataReducer";

const reducers = {
  data: DataReducer
};

export default reducers;
